class Loader {
  constructor () {
    this.parent = document.getElementById('mct-loader')
    this.element = document.getElementById('loader')
    this.elementText = document.getElementById('loader-text')
    this.hideTimeout = null
  }

  setStatusMessage (state, message) {
    this.element.setAttribute('data-loader-mode-value', state)
    this.elementText.textContent = message
    this.parent.classList.remove('hidden')

    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout)
      this.hideTimeout = null
    }

    if (state === 'success') {
      this.hideTimeout = setTimeout(() => {
        this.parent.classList.add('hidden')
        this.hideTimeout = null
      }, 5000)
    }
  }
}

export let loader = null

export function initLoader () {
  loader = new Loader()
  return loader
}
